<template>
	<svg :width="props.width" :height="props.height" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M30 57.0212V32.2031"
			:stroke="props.iconColor"
			stroke-width="1.6"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M30.1836 49.2117H31.332C35.3086 49.2117 38.5469 45.9671 38.5469 41.9827V40.832H37.3985C33.4219 40.832 30.1836 44.0767 30.1836 48.061V49.2117Z"
			:stroke="props.iconColor"
			stroke-width="1.6"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M20.7773 37.3105V38.4612C20.7773 42.4456 24.0156 45.6902 27.9922 45.6902H29.1407V44.5395C29.1407 40.5552 25.9024 37.3105 21.9258 37.3105H20.7773Z"
			:stroke="props.iconColor"
			stroke-width="1.6"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M30 32C22.2829 32 16 25.7222 16 18C16 10.2778 22.2778 4 30 4C37.7222 4 44 10.2778 44 18C44 25.7222 37.7222 32 30 32Z"
			:stroke="props.iconColor"
			stroke-width="1.6"
		/>
		<path
			d="M30.0038 15.1348C29.6802 15.1298 29.3718 15.1778 29.0786 15.2789C28.7904 15.38 28.5528 15.5191 28.3658 15.696C28.1838 15.8729 28.0928 16.0752 28.0928 16.3027C28.0928 16.6009 28.1787 16.8259 28.3506 16.9776C28.5275 17.1292 28.7601 17.2379 29.0483 17.3037C29.3364 17.3694 29.6549 17.4275 30.0038 17.4781C30.7217 17.5842 31.3839 17.7738 31.9906 18.0468C32.5973 18.3148 33.0826 18.6737 33.4466 19.1237C33.8157 19.5686 34.0002 20.112 34.0002 20.7541C34.0002 21.3355 33.851 21.8537 33.5528 22.3087C33.2595 22.7586 32.8627 23.1277 32.3622 23.4158C31.9855 23.6349 31.5767 23.7955 31.1358 23.8977C30.8932 23.954 30.709 24.1621 30.709 24.4112V25.0316C30.709 25.3077 30.4852 25.5316 30.209 25.5316H29.7985C29.5224 25.5316 29.2985 25.3077 29.2985 25.0316V24.4162C29.2985 24.165 29.1114 23.9555 28.8658 23.9025C28.5195 23.8277 28.1886 23.7186 27.8729 23.5751C27.428 23.3729 27.0412 23.1125 26.7126 22.794C26.5108 22.5922 26.3415 22.3718 26.2046 22.1327C26.0672 21.8926 26.2028 21.6012 26.4622 21.505L27.48 21.1278C27.7418 21.0307 28.04 21.1739 28.2467 21.3616C28.2745 21.3868 28.3041 21.4118 28.3354 21.4366C28.5275 21.5832 28.7677 21.7045 29.0559 21.8006C29.344 21.8916 29.66 21.9371 30.0038 21.9371C30.3324 21.9371 30.6408 21.8891 30.9289 21.793C31.2222 21.6919 31.4572 21.5529 31.6342 21.3759C31.8162 21.199 31.9072 20.9917 31.9072 20.7541C31.9072 20.5165 31.8137 20.3193 31.6266 20.1626C31.4395 20.0059 31.1994 19.882 30.9062 19.791C30.613 19.6949 30.3122 19.6216 30.0038 19.5711C29.2404 19.4599 28.5554 19.2804 27.9487 19.0327C27.3471 18.7799 26.8719 18.4336 26.523 17.9937C26.1742 17.5489 25.9998 16.9852 25.9998 16.3027C25.9998 15.7162 26.1464 15.1955 26.4396 14.7405C26.7379 14.2855 27.1347 13.9139 27.6302 13.6257C28.0115 13.4062 28.4252 13.2453 28.8711 13.1431C29.1141 13.0875 29.2985 12.8792 29.2985 12.6299V12.0176C29.2985 11.7414 29.5224 11.5176 29.7985 11.5176H30.209C30.4852 11.5176 30.709 11.7414 30.709 12.0176V12.6265C30.709 12.8773 30.8955 13.0864 31.1402 13.1411C31.4792 13.2168 31.8057 13.3278 32.1195 13.4741C32.5644 13.6763 32.9512 13.9392 33.2798 14.2627C33.4911 14.4677 33.6659 14.6939 33.8043 14.9414C33.9381 15.181 33.7999 15.4681 33.5419 15.5617L32.5179 15.9334C32.2567 16.0282 31.9612 15.8839 31.7528 15.7001C31.7251 15.6756 31.6957 15.6515 31.6645 15.6277C31.4724 15.4811 31.2323 15.3623 30.9441 15.2713C30.6559 15.1803 30.3425 15.1348 30.0038 15.1348Z"
			:fill="props.iconColor"
		/>
	</svg>
</template>
<script setup lang="ts">
const props = withDefaults(
	defineProps<{
		width?: string | number;
		height?: string | number;
		iconColor?: string;
	}>(),
	{
		width: 60,
		height: 60,
		iconColor: '#ffffff',
	}
);
</script>

<style lang="scss" scoped></style>
